import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../pages/Layout.vue'
import Page404 from '../pages/common/Page404.vue'
import Page500 from '../pages/common/Page500.vue'
import Privacy from '../pages/common/Privacy.vue'
import GDPR from '../pages/common/GDPR.vue'
import AML from '../pages/common/AML.vue'
import KYC from '../pages/common/KYC.vue'
import ContentPolicy from "../pages/common/ContentPolicy.vue"
import About from '../pages/about/About.vue'
import Poet from '../pages/about/Poet.vue'
import FrequentlyAskedQuestions from '../pages/about/FrequentlyAskedQuestions.vue'
//import Team from '../pages/about/Team.vue'
import investorrelations from '../pages/about/Investorrelations.vue'
import Contact from '../pages/about/Contact.vue'
import LostGoogleAuthentication from '../pages/faq/LostGoogleAuthentication.vue'
import Register from '../pages/user/Register.vue'
import Login from '../pages/user/Login.vue'
import Password from '../pages/user/Password.vue'
import ResetPassword from '../pages/user/ResetPassword.vue'
import RegisterSuccess from '../pages/user/RegisterSuccess.vue'
import Activation from '../pages/user/Activation.vue'
import EnableAuthentication from '../pages/user/EnableAuthentication.vue'
import ResetAuthentication from '../pages/user/ResetAuthentication.vue'
import CloseGoogleAuthentication from '../pages/user/CloseGoogleAuthentication.vue'
import UserKyc from '../pages/user/UserKyc.vue'
import UpdateEmail from '../pages/user/UpdateEmail.vue'
import UserFollow from '../pages/user/UserFollow.vue'
import UserData from '../pages/user/UserData.vue'
import UserSetting from '../pages/user/UserSetting.vue'
import UserRanking from '../pages/user/UserRanking.vue'
import UserWallet from '../pages/user/UserWallet.vue'
import Project from '../pages/project/Project.vue'
import CreateProject from '../pages/project/CreateProject.vue'
import AuditProject from '../pages/project/AuditProject.vue'
import ProjectDetail from '../pages/project/ProjectDetail.vue'
import ProjectIndex from '../pages/project/ProjectIndex.vue'
import Transaction from '../pages/token/Transaction.vue'
import TransactionData from '../pages/token/TransactionData.vue'
import Investment from '../pages/token/Investment.vue'
import InvestmentData from '../pages/token/InvestmentData.vue'
import UploadMaterial from '../pages/request/UploadMaterial.vue'
import UserRequest from '../pages/request/UserRequest.vue'
import MicroArticles from '../pages/microarticle/MicroArticles.vue'
import MicroArticle from '../pages/microarticle/MicroArticle.vue'
import Posts from '../pages/post/Posts.vue'
import Post from '../pages/post/Post.vue'
import TagPosts from '../pages/post/TagPosts.vue'
import MarketPosts from '../pages/post/MarketPosts.vue'
import SearchPosts from '../pages/post/SearchPosts.vue'
import CreatePost from '../pages/post/CreatePost.vue'
import Feed from '../pages/feed/Feed.vue'
import ImageUpload from '../components/ImageUpload.vue'
import Scroll from '../pages/test/Scroll.vue'
import Scrolling from '../pages/test/Scrolling.vue'
import TelegramUserMessages from '../pages/user/TelegramUserMessages.vue'
import Notification from '../pages/user/Notification.vue'
// import Tags from '../pages/tag/Tags.vue'

Vue.use(Router)

const router = new Router({
	//记住上一个页面的位置
	scrollBehavior (to, from, savedPosition) {
	  if (savedPosition) {
	    return savedPosition
	  } else {
	    return { x: 0, y: 0 }
	  }
	},
	routes:[
		/* {
			path:'/imageUpload',
			name:'imageUpload',
			component:ImageUpload
		},
		{
			path:'/scroll',
			name:'scroll',
			component:Scroll
		},
		{
			path:'/scrolling',
			name:'scrolling',
			component:Scrolling
		}, */
		//主页
		{ path:'/', name:'', component:Posts },
		//主页
		{ path:'/', name:'home', component:Posts },
		//404
		{ path:'*', name:'page404', component:Page404 },
		//500
		{ path:'*', name:'page500', component:Page500 },
		//Privacy
		{ path:'/about/privacy', name:'privacy', component:Privacy },
		//GDPR
		{ path:'/about/GDPR', name:'GDPR', component:GDPR },
		//AML
		{ path:'/about/AML', name:'AML', component:AML },
		//Content Policy
		{ path:'/about/ContentPolicy', name:'ContentPolicy', component:ContentPolicy },
		//KYC
		{ path:'/about/KYC', name:'KYC', component:KYC },
		//ABOUT
		{ path:'/about', name:'about', component:About },
		//PoET
		{ path:'/about/poet', name:'poet', component:Poet },
		//FrequentlyAskedQuestions
		{ path:'/about/frequently-asked-questions', name:'frequently-asked-questions', component:FrequentlyAskedQuestions },
		//TEAM
		//{ path:'/about/team', name:'team', component:Team },
		//TEAM
		{ path:'/ir', name:'investorrelations', component:investorrelations },
		//TEAM
		{ path:'/about/contact', name:'contact', component:Contact },
		//丢失谷歌认证码
		{ path:'/faq/authentication/lost', name:'lostGoogleAuthentication', component:LostGoogleAuthentication },
		//注册
		{ path:'/register', name:'register', component:Register },
		//找回密码
		{ path:'/password', name:'password', component:Password },
		//重置密码
		{ path:'/resetPassword', name:'resetPassword', component:ResetPassword },
		//注册成功
		{ path:'/registersuccess', name:'registersuccess', component:RegisterSuccess },
		//激活
		{ path:'/activation', name:'activation', component:Activation },
		//启用二级认证
		{ path:'/user/2fa/enable', name:'enableAuthentication', component:EnableAuthentication, meta:{requireAuth:true} },
		//个人资料
		{ path:'/user/profile/:username', name:'userData', component:UserData },
		//设置
		{ path:'/user/settings', name:'userSetting', component:UserSetting, meta:{requireAuth:true} },
		//更新邮箱
		{ path:'/updateEmail', name:'updateEmail', component:UpdateEmail },
		//关注
		{ path:'/user/follow/:username', name:'follow', component:UserFollow },
		//钱包
		{ path:'/user/wallet', name:'wallet', component:UserWallet, meta:{requireAuth:true} },
		//关闭2-FA
		{ path:'/authentication/close/:emailLinkId', name:'closeGoogleAuthentication', component:CloseGoogleAuthentication },
		// 提交请求
		{ path:'/request/new', name:'userRequest', component:UserRequest },
		// 用户排行
		{ path:'/user/ranking', name:'userRanking', component:UserRanking },
		// 提交请求
		{ path:'/material/upload/:requestId', name:'uploadMaterial', component:UploadMaterial },
		// 实名认证
		{ path:'/user/kyc', name:'userKyc', component:UserKyc, meta:{requireAuth:true} },
		// 消息通知
		{ path:'/user/notifications', name:'notification', component:Notification, meta:{requireAuth:true} },

		// {
		//  	path:'/resetAuthentication/:userId',
		//  	name:'resetAuthentication',
		//  	component:ResetAuthentication,
		//  	meta:{requireAuth:true}
		// },
		// {
		//  	path:'/realNameAuthentication/:userId',
		//  	name:'realNameAuthentication',
		//  	component:RealNameAuthentication,
		//  	meta:{requireAuth:true}
		// },
		//项目
		// {
		//  	path:'/project',
		//  	name:'project',
		//  	component:Project
		// },
		// {
		//  	path:'/createProject',
		//  	name:'createProject',
		//  	component:CreateProject,
		//  	meta:{requireAuth:true}
		// },
		// {
		//  	path:'/auditProject',
		//  	name:'auditProject',
		//  	component:AuditProject,
		// },
		// {
		//  	path:'/projectDetail',
		//  	name:'projectDetail',
		//  	component:ProjectDetail
		// },
		// {
		// 	path:'/projectIndex',
		// 	name:'projectIndex',
		// 	component:ProjectIndex
		// },
		{ path:'/post/create', name:'createPost', component:CreatePost, meta:{requireAuth:true} },
		// 文章主页
		{ path:'/posts', name:'posts', component:Posts },
		// 根据标签查找帖子
		{ path:'/posts/tags/:tagName', name:'tagPosts', component:TagPosts },
		// 根据市场查找帖子
		{ path:'/posts/topics/:marketsName', name:'marketPosts', component:MarketPosts },
		// 根据搜索条件查询帖子
		{ path:'/posts/search/:searchText', name:'searchPosts', component:SearchPosts },
		//我的关注页面
		{ path:'/feed/:username', name:'feed', component:Feed },
		//帖子详情页
		{ path:'/post/:postingId', name:'postingsel', component:Post },
		//交易记录列表页
		{ path:'/transaction', name:'transaction', component:Transaction },
		//交易记录详情页
		{ path:'/transactionData/:txHash', name:'transactionData', component:TransactionData },
		//投资记录列表页
		{ path:'/investment', name:'investment', component:Investment, meta:{requireAuth:true} },
		//投资记录详情页
		{ path:'/investmentData/:investmentId', name:'investmentData', component:InvestmentData, meta:{requireAuth:true} },
		//微文列表主页
		{ path:'/microarticles', name:'microArticles', component:MicroArticles },
		//微文详情页面
		{ path:'/microarticle/:userName/:microArticleId', name:'microArticle', component:MicroArticle },
		//telegram消息页面
		{ path:'/telegram/chat',name:'telegramusermessages',component:TelegramUserMessages}
		// 所有标签页
		// { path:'/tags',name:'tags',component:Tags},
	]
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js